// 统一管理请求
import requests from "./axios.js";

export default {
  getall() {
    return requests.get("/api/upload/img");
  },
  //查询全部新闻
  allNew(parms) {
    return requests.post("/article/queryList",parms);
  },

  //查询单个新闻
  oneNew(parms) {
    return requests.get("/article/queryOne/" + parms);
  },


  //////////首页发展历程////////////////////
  //查询全部
  homeAll(parms){
    return requests.get(`/homeData/homeAll?order=${parms}`);
  },
};
